<template>
    <PullRefresh v-model="isLoading" success-text="刷新成功" @refresh="onRefresh" :disabled="dialogVisible">
      <div :class="$style.container">
        <div :class="$style.banner">
          <img :src="activeInfo.backgroundImage" />
        </div>
        <div :class="$style.gameDetail">
          <div>
            <img :src="activeInfo.logo" alt="" :class="$style.icon" />
            <div :class="$style.info">
              <p :class="$style.name">{{ activeInfo.appName }}</p>
              <p :class="$style.categoryNames">
                {{
                  activeInfo.categoryNames && activeInfo.categoryNames.join("·")
                }}
              </p>
              <p :class="$style.tags">
                <span
                  v-for="item in activeInfo.tags"
                  :key="item.id"
                  >{{ item.labelName }}</span
                >
              </p>
            </div>
            <button :class="$style.download" @click="onHandleGame(false)">
              查看/下载
            </button>
          </div>
        </div>
        <div :class="$style.punchBox">
          <div :class="$style.punch">
            <!-- <img @click="onClickChangeGameBtn" :class="$style.changeGameBtn" :src="`${CDN_URL_1}/box_weekSignIn_blue/changeGameBtn.png`" alt="" /> -->
            <div :class="$style.content">
              <div :class="$style.signInNum">本周已累计攒能量{{signDays}}次</div>
              <div :class="$style.switch">
                <p style="margin-right: 4px;">{{tipSwitch?'已':''}}开启提醒</p>
                <van-switch :value="tipSwitch" size="17px" active-color="#6F83FF" @change="onClickSwitch"/> 
              </div>
            </div>
            <div :class="$style.time">
              <CountDown :time="countdownTime" @finish="onRefresh">
                <template #default="timeData">
                  <span>礼包刷新倒计时：{{ timeData.days }}天</span>
                  <span>{{ timeData.hours }}时</span>
                  <span>{{ timeData.minutes }}分</span>
                  <span>{{ timeData.seconds }}秒</span>
                </template>
              </CountDown>
             </div>
            <!-- 进度 -->
            <div :class="$style.signProcess">
              <div :class="$style.signProcessLine">
                <div :class="$style.signProcessLineActive" :style="`width:${signDays * 50}%`"></div>
                <span :class="$style.tipDesc" style="left: -7px;">攒1次</span>
                <span :class="$style.tipDesc" style="left: 0;right: 0;margin: auto;">攒2次</span>
                <span :class="$style.tipDesc" style="right: -8px;">攒3次</span>
                <img :class="$style.tipImg" style="left: -13px;" :src="`${CDN_URL_1}/box_weekSignIn_blue/message.png`" alt="" />
                <img :class="$style.tipImg" style="left: 0;right: 0;margin: auto;" :src="`${CDN_URL_1}/box_weekSignIn_blue/message.png`" alt="" />
                <img :class="$style.tipImg" style="right: -13px;" :src="`${CDN_URL_1}/box_weekSignIn_blue/message.png`" alt="" />
                <img v-if="signDays > 0" :class="$style.signNode1" :src="signInImage" alt="0" />
                <img v-if="signDays > 1" :class="$style.signNode2" :src="signInImage" alt="1" />
                <img v-if="signDays > 2" :class="$style.signNode3" :src="signInImage" alt="2" />
              </div>
            </div>
            <!-- 礼包内容 -->
            <div :class="$style.giftWrapper">
              <div v-if="activeInfo.oneDayGifts" :class="$style.giftContent">
                <img :class="$style.icon" :src="activeInfo.oneDayGifts[0].giftIcon"/>
                <p :class="$style.title">{{activeInfo.oneDayGifts[0].giftName}}</p>
                <div :class="$style.desc">{{activeInfo.oneDayGifts[0].giftDetail}}</div>
                <div :class="$style.btn" @click="onClickGiftBtn({...activeInfo.oneDayGifts[0],gift_type:1})" :style="`filter: ${activeInfo.oneDayGifts[0].giftState !== 0 ? 'grayscale(1)':'none'}`">
                  {{giftStateText[activeInfo.oneDayGifts[0].giftState]}}
                </div>
              </div>
              <div v-if="activeInfo.threeDayGifts" :class="$style.giftContent">
                <img :class="$style.icon" :src="activeInfo.threeDayGifts[0].giftIcon"/>
                <p :class="$style.title">{{activeInfo.threeDayGifts[0].giftName}}</p>
                <div :class="$style.desc">{{activeInfo.threeDayGifts[0].giftDetail}}</div>
                <div :class="$style.btn" @click="onClickGiftBtn({...activeInfo.threeDayGifts[0],gift_type:3})" :style="`filter: ${activeInfo.threeDayGifts[0].giftState !== 0 ? 'grayscale(1)':'none'}`">
                  {{giftStateText[activeInfo.threeDayGifts[0].giftState]}}
                </div>
              </div>
            </div>
            <div :class="$style.punchBtn" id="footerBtn" 
              :style="`backgroundImage: url(${CDN_URL_1}/box_weekSignIn_blue/signBtn.png);filter: ${signStatus !== 0 ? 'grayscale(1)':'none'}`">
              <p v-if="signStatus == 0" @click="punchIn">点我攒能量</p>
              <p v-if="signStatus == 1">今日已攒能量</p>
              <p v-if="signStatus == 2">本周能量已攒满</p>
              <p v-if="signStatus == 3" @click="unSatisfiedHint">
                不满足活动条件
              </p>
            </div>
          </div>
        </div>
        <div :class="$style.dialog" v-if="dialogVisible">
          <header>
            <span>{{ dialogTitle }}</span>
            <img
              :src="closeImg"
              alt=""
              :class="$style.close"
              @click="dialogVisible = false"
            />
          </header>
          <main>
            <div v-if="dialogType === 0">
              <p style="text-align: center">本周已累计攒能量{{ signDays }}次</p>
              <p style="text-align: center">累计签到打卡1、3次可领取礼包</p>
              <p style="text-align: center">明天记得也来攒能量哦~</p>
            </div>
            <div v-if="dialogType === 1">
              <p style="text-align: center">
                礼包码已存放在
              </p>
              <p style="text-align: center;width: 100%">
                【我的】—【我的礼包】—【活动礼包】
              </p>
            </div>
  
            <div v-if="dialogType === 2">
              <p style="text-align: center">
                未查询到<span>[{{activeInfo.appName}}]</span>游戏记录
              </p>
              <p style="text-align: center">点击下载游戏即可参与</p>
            </div>
  
            <div v-if="dialogType === 3">
              <p>兑换码生成错误，请联系客服领取备用码</p>
            </div>
            <!-- <div v-if="dialogType === 4" :class="$style.gameList">
              <div v-for="item in gameList" :key="item.id" :class="$style.gameItem">
                <img :src="item.logo" />
                <div :class="$style.game" >
                  <div :class="$style.title">{{item.appName}}</div>
                  <div :class="$style.value">{{item.giftValue}}</div>
                </div>
                <div :class="$style.placeBtn" @click="onClickGamePlace(item.id)">进入会场</div>
              </div>
            </div> -->
            <!-- 按钮 -->
            <div
              v-if="dialogType !== 4"
              :class="$style.btnGroup"
              :style="{
                justifyContent: dialogType === 2 ? 'space-between' : 'center',
              }"
            >
              <button
                v-if="dialogType == 2"
                :class="$style.cancelBtn"
                @click="dialogVisible = false"
              >
                {{ cancelText }}
              </button>
              
              <button
                  v-if="dialogType === 1"
                  :class="$style.sureBtn"
                  @click="onClickGiftCdk"
                >
                {{ sureText }}
              </button>
              <button
                v-else-if="dialogType === 2"
                @click="onHandleGame(true)"
                :class="$style.sureBtn"
              >
                {{ sureText }}
              </button>
              <button
                v-else-if="dialogType === 3"
                @click="onRelationServer"
                :class="$style.sureBtn"
              >
                {{ sureText }}
              </button>
              <button
                v-else
                :class="$style.sureBtn"
                @click="dialogVisible = false"
              >
                {{ sureText }}
              </button>
            </div>
          </main>
        </div>
        <div :class="$style.mask" v-if="dialogVisible"></div>
      </div>
    </PullRefresh>
  </template>
  <script>
  import {
    getWeekSignInActiveListApi,
    getWeekSignInActivePlacesApi,
    setWeekSignInActiveApi,
    getWeekSignInActiveGiftApi
  } from "../../apis/wxActivity";
  import { CDN_URL_1, CDN_URL } from "@/config";
  import { getCookie } from "@/libs/utils";
  import {
    setPageTitle,
    jumpToNative,
    clickRightTxt,
    setRightTxtColor,
    setRightTxt,
    toLogin,
    openNotification,
    isOpenNotification,
    dataLoadFinished,
    signInEventTrack
  } from "@/bridge/AppJsBridge";
  import { inithandler } from "@/bridge/jsBridge";
  
  import { PullRefresh, CountDown } from "vant";
  import { burnPoint } from "@/apis/heziShare";
  import moment from "moment";
  import { queue } from "../../libs/queue.request";

  const ACTIVITY_NAME = "攒能量拿礼包";
  
  export default {
    components: {
      PullRefresh,CountDown
    },
    data() {
      return {
        pageTitle: ACTIVITY_NAME,
        closeImg: `${CDN_URL}/packet/close.png`,
        CDN_URL_1,
        dialogVisible: false,
        dialogType: 0, // 0. 打卡 1. 礼包领取成功 2.不满足活动条件 3.礼包码生成错误
        dialogTitle: "打卡成功",
        cancelText: "开启提醒",
        sureText: "我知道了",
        isLoading: false,
        cookie: null,
        tipSwitch: false,
        unSignInImage:`${CDN_URL_1}/box_weekSignIn_blue/unSignIn.png`,
        signInImage:`${CDN_URL_1}/box_weekSignIn_blue/signIn.png`,
        signDays: 0, // 签到天数
        signStatus: 0, // 当天签到状态
        activeInfo: {}, // 活动数据
        gameList:[],
        giftStateText:{ 0:'可领取', 9:'已领取', 1:'累计打卡1天可领', 3:'累计打卡3天可领',}, // 0-可领取 9-已领取 1-累计打卡1天可领 3-累计打卡3天可领
        curId: 0,
        giftName: "", // 当前领取礼包名称
        giftId: "", // 当前领取礼包id
        giftType: null,
        reqQueue: queue(),
      };
    },
    created() {
      // 页面初始化
      // inithandler();
      this.reqQueue.create();
      this.getBaseInfo();
      try {
        signInEventTrack((data) => {
          this.cookie = JSON.parse(data);
        });
      } catch (error) {
        // 错误处理
      }
    },
    computed: {
      countdownTime: function(){
        let time = 7*24*60*60*1000;
        if (this.activeInfo.nowTime && this.activeInfo.nextTime) {
          time = moment(this.activeInfo.nextTime).valueOf() - moment(this.activeInfo.nowTime).valueOf();
        }
        return time
      }
    },
    activated() {
      setRightTxt("活动规则");
      this.dialogVisible = false;
      setPageTitle(this.pageTitle);
    },
    watch: {
      cookie(value, oldValue){
        if (!oldValue && value && !getCookie()) {
          this.reqQueue.run(value);
        }
      },
    },
    methods: {
      // 下拉刷新
      async onRefresh() {
        await this.getBaseInfo();
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
      },
      // 设置顶部内容
      setHeaderContent() {
        setRightTxtColor("#0066ff");
        setRightTxt("活动规则");
        try {
          clickRightTxt(() => {
            this.$router.push({
              name: `box.actPlaceRule`,
              params: {
                type: 16
              },
            });
            this.eventTrack({
              event: "week_sign_rule",
              event_field: JSON.stringify({activity_name: ACTIVITY_NAME}),
            });
          });
        } catch (error) {
          console.log("error: ", error)
        }
      },
      // 数据上报
      eventTrack(data) {
        // this.$toast(data.event)
        const params = {
          ...data,
          appName: this.activeInfo.appName,
          appkey: this.activeInfo.gameId,
        }
        if (!this.cookie) {
          console.log("数据上报异常", data.event,"转为补充数据上报")
          this.reqQueue.add(burnPoint,params)
          return
        }
        console.log("正常数据上报", data.event)
        burnPoint({
          ...this.cookie,
          ...params
        }).catch((err) => console.log(err));
      },
  
      // 跳转系统权限
      onClickSwitch(value){
        if (!this.activeInfo.appName) {
          return
        }
        openNotification();
        this.eventTrack({
          event: "week_sign_open_tip",
          event_field: JSON.stringify({activity_name: ACTIVITY_NAME,tip_status: Number(this.tipSwitch)}),
        });
      },
      // 页面初始化
      async getBaseInfo() {
        setPageTitle(this.pageTitle);
        const { history } = this.$router;
        const { query } = history.current; 
        console.log("🚀 ~ file: weekSignInActV2.vue:351 ~ getBaseInfo ~ params:", query)
        if (query.id) {
          this.curId = query.id;
        }
        const pageCookie = getCookie();
        if (pageCookie) {
          for (const key in pageCookie) {
            if (
              Object.hasOwnProperty.call(pageCookie, key) &&
              pageCookie[key] === "null"
            ) {
              delete pageCookie[key];
            }
          }
          this.cookie = pageCookie;
        }
        this.setHeaderContent();
        this.getPageMainData(this.curId);  
      },
      getPageMainData(id = 0){
        getWeekSignInActiveListApi({id}).then(res => {
          this.activeInfo = res.data;
          this.signDays = res.data.signDays;
          this.signStatus = res.data.signStatus;
          this.eventTrack({
            event: "week_sign_page",
            event_field: JSON.stringify({activity_name: ACTIVITY_NAME}),
          });
          dataLoadFinished();
          this.getTipSwitchStatus();
        }).catch( (error) => {
          let errorInfo = error.response;
          const {data} = errorInfo;
          if (data && data.code === 401) {
            toLogin("/loginKey/LoginByKeyPhoneActivity");
          }
        });
      },
  
      /**
       * 获取当前页面通知权限开关状态
       */
      getTipSwitchStatus(){
        isOpenNotification(status => {
          // 首次进入此方法无效，后续修改开关返回当前页面获取状态更新
          this.tipSwitch = status == '1' ? true : false;
          this.eventTrack({
            event: "week_sign_open_tip",
            event_field: JSON.stringify({activity_name: ACTIVITY_NAME,tip_status: Number(status)}),
          });
        })
      },
  
      /**
       * 点击进入会场
       */
      onClickGamePlace(id){
        this.eventTrack({
          event: 'week_sign_entry_branch',
          event_field: JSON.stringify({ activity_name: ACTIVITY_NAME }),
        });
        if (id === this.activeInfo.id) {
          this.$toast('当前已在该会场，请关闭弹窗或选择进入其他会场~')
          return
        }
        this.curId = id;
        this.getPageMainData(id);
        this.dialogVisible = false;
        this.$toast('游戏会场切换成功~')
      },
      
      // 点击打卡
      async punchIn() {
        if (!this.activeInfo.id ) {
          return
        }
        this.eventTrack({
          event: "week_sign_sign_icon",
          event_field: JSON.stringify({ activity_name: ACTIVITY_NAME,icon_type:1 }),
        });
        setWeekSignInActiveApi({ id: this.activeInfo.id }).then(res => {
          const {data} = res;
          // 刷新页面
          this.getPageMainData(this.activeInfo.id);
          if (!data.signState) {
            this.$toast('打卡失败，请重试~')
            return
          }
          this.dialogVisible = true;
          this.dialogType = 0;
          this.dialogTitle = "今日已攒能量";
          this.sureText = "我知道了";
          this.eventTrack({
            event: "week_sign_sign_result_pop",
            event_field: JSON.stringify({ activity_name: ACTIVITY_NAME,sign_result:1 }),
          });
        }).catch(error => {
          // 刷新页面
          this.getPageMainData(this.activeInfo.id);
        });
        
      },
  
      // 不满足活动条件按钮点击
      unSatisfiedHint() {
        this.dialogType = 2;
        this.dialogTitle = "不满足活动条件";
        this.cancelText = "取消";
        this.sureText = "下载/查看游戏";
        this.dialogVisible = true;
        this.eventTrack({
          event: "week_sign_sign_icon",
          event_field: JSON.stringify({ activity_name: ACTIVITY_NAME,icon_type:2 }),
        });
        this.eventTrack({
          event: "week_sign_sign_result_pop",
          event_field: JSON.stringify({ activity_name: ACTIVITY_NAME,sign_result:2 }),
        });
      }, 
  
      /**
       * 点击去切换游戏会场弹窗
       */
      // onClickChangeGameBtn(){
      //   this.eventTrack({
      //     event: 'week_sign_change_branch',
      //     event_field: JSON.stringify({ activity_name: ACTIVITY_NAME }),
      //   });
      //   this.dialogType = 4;
      //   this.dialogTitle = "选择游戏会场";
      //   getWeekSignInActivePlacesApi().then(res => {
      //     if (!res.data || res.data.length <= 1) {
      //       this.$toast('暂无其他游戏会场');
      //       return
      //     }
      //     this.gameList = res.data;
      //     this.dialogVisible = true;
      //   })
      // },
  
      async onClickGiftBtn(giftInfo) {
        const { giftState, id, giftName,gift_type } = giftInfo;
        const successAction = (hasEvent=true) => {
          this.dialogVisible = true;
          this.dialogType = 1; 
          this.dialogTitle = "领取成功";
          this.sureText = '查看礼包码';
          this.giftName = giftName;
          this.giftId = id;
          this.giftType = gift_type;
          if (hasEvent) {
            this.eventTrack({
              event: "week_sign_gifts_get_pop",
              event_field: JSON.stringify({activity_name: ACTIVITY_NAME, gift_id: id,gift_name: giftName,sign_days:this.signDays,get_result: 1,gift_type}),
            });
          }
        }
        const errorAction = (result) => {
          this.dialogVisible = true;
          this.dialogType = 3;
          this.dialogTitle = "提示";
          this.sureText = '联系客服';
          this.eventTrack({
            event: "week_sign_gifts_get_pop",
            event_field: JSON.stringify({activity_name: ACTIVITY_NAME, gift_id: id,gift_name: giftName,sign_days:this.signDays,get_result: result,gift_type}),
          });
        }
        if (giftState == 0) {
          this.eventTrack({
            event: "week_sign_gift_get",
            event_field: JSON.stringify({activity_name: ACTIVITY_NAME, gift_id: id,gift_name: giftName,sign_days:this.signDays,gift_type}),
          });
          getWeekSignInActiveGiftApi({id: this.activeInfo.id,giftId: id}).then(res => {
            const { data } = res;
            if (data.cdk) {
              successAction();
            }else{
              errorAction(1);
            }
            // 领取后刷新页面
            this.getPageMainData(this.activeInfo.id);
          }).catch(error => {
            errorAction(0);
            // 领取后刷新页面
            this.getPageMainData(this.activeInfo.id);
          })
          // 可领取
          return
        }
        if (giftState == 9) {
          successAction(false);
          // 已领取
          return
        }
      },
  
      // 跳转礼包
      onClickGiftCdk(){
        this.eventTrack({
          event: "week_sign_pop_copy_code",
          event_field: JSON.stringify({ activity_name: ACTIVITY_NAME, gift_id:this.giftId, gift_name:this.giftName, sign_days:this.signDays,gift_type: this.giftType  }),
        });
        const data = {
          routePath: "/gift/MineGiftActivity",
          extraParams: 3,
        };
        const dataStr = JSON.stringify(data);
        jumpToNative(dataStr);
        this.dialogVisible = false;
      },
      
      // 游戏详情
      onHandleGame(isPop = false) {
        if (!this.activeInfo.gameId) {
          return
        }
  
        let event = "";
        if (isPop) {
          event = "week_sign_pop_downlod_game";
        } else {
          event = "week_sign_game_scan";
        }
        this.eventTrack({
          event: event,
          event_field: JSON.stringify({ activity_name: ACTIVITY_NAME }),
        });
        const data = {
          routePath: "/main/game/GameDetailActivity",
          extraParams: this.activeInfo.gameId,
          fromPageType: 44,
        };
        const dataStr = JSON.stringify(data);
        jumpToNative(dataStr);
        this.dialogVisible = false;
      },
  
      // 联系客服
      onRelationServer() {
        // localStorage.setItem(`${this.cookie.userId}_id`, this.curId);
        this.$router.push({
          name: `box.customerService`,
        });
      },
    },
  };
  </script>
  <style lang="scss" module>
  .container {
    width: 100vw;
    min-height: 100vh;
    overflow-y: auto;
    padding-top: 10px;
    background: url("#{$cdn-url-2}/box_weekSignIn_blue/pageBg.jpg") no-repeat;
    background-size: 100% 100%;
    .banner {
      display: block;
      width: 91%;
      margin: auto;
      padding: 4px;
      border-radius: 4px;
      background-color: #6F83FF;
      box-shadow: 1px 1px 3px rgb(0 0 0 / 35%), -1px -1px 3px rgb(0 0 0 / 35%);
      > img {
        display: block;
        width: 100%;
        max-height: 196px;
        margin: auto;
        border: 1px solid rgba(255,255,255,.3);
      }
    }
    .gameDetail {
      display: block;
      width: 340px;
      height: 92px;
      margin: auto;
      padding: 4px;
      border-radius: 4px;
      background-color: #6F83FF;
      box-shadow: 1px 1px 3px rgb(0 0 0 / 35%), -1px -1px 3px rgb(0 0 0 / 35%);
      margin-top: 10px;
  
      > div {
        background: #e2e6ff;
        width: 100%;
        height: 100%;
        padding: 10px;
        display: flex;
        align-items: center;
        position: relative;
        .icon {
          width: 66.7px;
          height: 66.7px;
        }
        .info {
          margin-left: 4px;
          .name {
            font-size: 15px;
            font-weight: 500;
            text-align: left;
            color: #333333;
            margin-bottom: 9px;
          }
          .categoryNames {
            font-size: 12px;
            font-weight: 400;
            text-align: left;
            color: #999999;
            margin-bottom: 8px;
          }
          .tags {
            > span {
              background: linear-gradient(0deg,#669bf7 0%, #5bbbf9 100%);
              border-radius: 2px;
              padding: 1px 6px;
              font-size: 12px;
              margin-right: 2px;
              color: #fff;
            }
          }
        }
        .download {
          position: absolute;
          right: 14px;
          border: none;
          outline: none;
          background: none;
          // width: 59px;
          height: 24px;
          border: 1px solid #669CF7;
          border-radius: 12.85px;
          color: #669CF7;
          &:active {
            opacity: 0.8;
          }
        }
      }
    }
    .punchBox{
      width: 340px;
      margin: 10px auto 0;
      padding: 4px;
      border-radius: 4px;
      background-color: #6F83FF;
      box-shadow: 1px 1px 3px rgb(0 0 0 / 35%), -1px -1px 3px rgb(0 0 0 / 35%);
    }
    .punch {
      min-height: 430px;
      padding: 12px;
      position: relative;
      background: #fff;
      .changeGameBtn{
        width: 115px;
      }
      .content{
        margin-top: 13px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .signInNum{
          font-size: 17px;
          font-weight: 700;
          text-align: left;
          color: #333333;
          line-height: 17px;
        }
        .switch{
          font-size: 13px;
          font-weight: 400;
          color: #999998;
          line-height: 17px;
          display: flex;
          align-items: center;
        }
      }
  
      .time{
        font-size: 13px;
        font-weight: 400;
        text-align: left;
        color: #999998;
        // line-height: 13px;
        margin-top: 6px;
        display: flex;
        align-items: center;
        span{
          font-size: 13px;
          font-weight: 400;
          color: #999998;
          line-height: 13px;
        }
      }
      .signProcess{
        height: 90px;
        padding-top: 80px;
      }
      .signProcessLine{
        width: 210px;
        height: 12px;
        // background: #ebedee;
        // border-radius: 4px;
        background: url("#{$cdn-url-2}/box_weekSignIn_blue/processBg.png") no-repeat;
        // background-size: 100% 100%;
        background-size: cover;
        margin: 0 auto;
        position: relative;
        .signProcessLineActive{
            width: 100%;
            height: 4px;
            background: #1b8aff;
            position: absolute;
            top: 5px;
        }
        .tipImg{
          position: absolute;
          width: 40px;
          bottom: 20px;
        }
        .tipDesc{
          position: absolute;
          bottom: 31px;
          font-size: 12px;
          font-weight: 400;
          text-align: center;
          color: #ffffff;
          line-height: 13px;
          z-index: 1;
        }
        .signNode1{
          position: absolute;
          width: 26px;
          bottom: -8px;
          left: -5px;
        }
        .signNode2{
          position: absolute;
          width: 26px;
          bottom: -8px;
          left: 0;
          right: 0;
          margin: 0 auto;
        }
        .signNode3{
          width: 26px;
          position: absolute;
          bottom: -8px;
          right: -5px;
        }
      }
  
      .giftWrapper{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 22px;
        .giftContent{
          width: 120px;
          max-height: 180px;
          text-align: center;
          .icon{
            width: 50px;
            height: 48px;
          }
          .title{
            height: 14px;
            font-size: 14px;
            font-weight: 700;
            color: #666666;
            line-height: 14px;
            margin-top: 12px;
          }
          .desc{
            width: 110px;
            min-height: 50px;
            font-size: 13px;
            font-weight: 500;
            color: #ff7a2a;
            line-height: 14px;
            text-align: left;
            letter-spacing: -0.44px;
            margin: 8px auto 4px;
          }
          .btn{
            width: 119px;
            height: 32px;
            line-height: 32px;
            margin: auto;
            background: linear-gradient(60deg,#44b5ff 0%, #2188ff 100%);
            border-radius: 16px;
            box-shadow: 0 1px 3.47px 0px rgba(33,129,251,0.4); 
            font-size: 13px;
            font-weight: 500;
            text-align: center;
            color: #ffffff;
          }
        }
      }
  
      .punchBtn {
        margin: 50px auto 79px;
        width: 98%;
        height: 46px;
        background-size: 100% 100%;
        > p {
          width: 100%;
          line-height: 40px;
          font-size: 16px;
          font-weight: 500;
          text-align: center;
          color: #fff;
        }
      }
    }
    .dialog {
      width: 306px;
      min-height: 200px;
      position: fixed;
      top: 32%;
      left: 0;
      right: 0;
      // bottom: 0;
      margin: auto;
      background-color: #ffffff;
      z-index: 100;
      border-radius: 4px;
      overflow: hidden;
      > header {
        display: flex;
        background: linear-gradient(90deg, #ff782c 0%, #ffb503 100%);
        font-size: 19px;
        color: #ffffff;
        justify-content: center;
        align-items: center;
        font-weight: 700;
        height: 37px;
        .close {
          position: absolute;
          top: 8px;
          right: 10px;
          width: 16px;
          height: 16px;
        }
      }
      > main {
        text-align: center;
        padding-top: 30px;
        .bt {
          font-size: 18px;
          font-weight: 700;
          color: #ff612c;
          margin-bottom: 30px;
          text-align: center;
        }
        p {
          width: 230px;
          margin: auto;
          text-align: left;
          font-size: 16px;
          line-height: 24px;
          > span {
            color: #ff612c;
          }
        }
        .hint {
          font-size: 13px;
          color: #666666;
        }
      }
  
      .gameList{
        overflow: auto;
        max-height: 345px;
        .gameItem{
          width: 100%;
          padding: 0 12px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 12px;
          >img{
            width: 44px;
            height: 44px;
          }
          .game{
            flex: 1;
            margin: 0 12px;
            text-align: left;
            .title{
              font-size: 13.5px;
              font-weight: 500;
              color: #333333;
              margin-bottom: 4px;
            }
            .value{
              font-size: 13.5px;
              font-weight: 500;
              color: #999999;
            }
          }
          .placeBtn{
            width: 78px;
            height: 25px;
            line-height: 25px;
            border: 1px solid #fc5f5e;
            border-radius: 13px;
            font-size: 13px;
            font-weight: 500;
            text-align: center;
            color: #fc5f5e;
          }
        }
      }
      .btnGroup {
        // position: absolute;
        // bottom: 20px;
        display: flex;
        justify-content: space-between;
        width: 80%;
        // left: 0;
        // right: 0;
        margin: 30px auto 20px;
        > button {
          border: none;
          outline: none;
          width: 105px;
          height: 35px;
          font-size: 13px;
          border-radius: 35px;
          justify-content: center;
          align-items: center;
          color: #ffffff;
          &:active {
            opacity: 0.8;
          }
        }
        .cancelBtn {
          background: #fff2f2;
          color: #fc5f5e;
        }
        .sureBtn {
          background: #fd383c;
          color: #ffffff;
        }
      }
    }
    .mask {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.6);
      z-index: 99;
    }
  }
  </style>
  